<template>
  <validation-observer ref="validator" #default="{valid}">
    <b-form @submit.prevent="submit" @reset.prevent="clear">

      <validation-provider
        #default="validationContext"
        name="name"
        rules="required"
      >
        <b-form-group
          id="input-group-1"
          label="Nome:"
          label-for="list-name"
        >
          <b-form-input
            id="list-name"
            type="text"
            v-model="name"
            :state="getValidationState(validationContext)"
          ></b-form-input>
          <b-form-invalid-feedback>
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <validation-provider
        #default="validationContext"
        name="description"
      >
        <b-form-group
          id="input-group-1"
          label="Descrição:"
          label-for="list-description"
        >
          <b-form-input
            id="list-description"
            type="text"
            v-model="description"
            :state="getValidationState(validationContext)"
          ></b-form-input>
          <b-form-invalid-feedback>
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <b-form-row v-if="(showSubmit || showReset)" class="justify-end">
        <b-col v-if="showSubmit" cols="auto">
          <b-button :disabled="!valid" type="submit" variant="primary">
            <slot name="submit-button-text">Salvar</slot>
          </b-button>
        </b-col>
        <b-col v-if="showReset" cols="auto">
          <b-button type="reset" variant="outline-secondary">
            <slot name="reset-button-text">Limpar</slot>
          </b-button>
        </b-col>
      </b-form-row>
    </b-form>
  </validation-observer>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BFormRow,
  BCol,
  BFormInvalidFeedback,
  BInputGroupAppend,
  BInputGroup,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import { required, min } from '@validations'

export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BFormRow,
    BFormInvalidFeedback,
    BCol,
    ValidationObserver,
    ValidationProvider,
    BInputGroup,
    BInputGroupAppend,
  },

  props: {
    model: {
      type: Object,
      default: () => null
    },
    showSubmit: {
      type: Boolean,
      default: true
    },
    showReset: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({
    name: '',
    description: '',
    required,
    min
  }),

  methods: {
    loadModel(model) {
      this.name = model.name || ''
      this.description = model.description || ''
    },
    submit() {
      this.$emit('submit', {name: this.name, description: this.description})
    },
    clear() {
      this.$emit('reset')
      this.name = ''
      this.description = ''
    },
    getValidationState({ dirty, validated, required: fieldRequired, changed, valid = null }){
      const result = dirty || validated ? valid : null
      return !fieldRequired && !changed ? null : result
    },
    showValidationErrors(error) {
      this.showErrors(this.$refs.validator, error)
    }
  },

  watch: {
    model(value) {
      if (value) this.loadModel(value)
    }
  },

  mounted() {
    if (this.model) {
      this.loadModel(this.model)
    }
  }
}
</script>

<style>

</style>
